import { GMBChartsFactory } from "./charts/gmb-charts-factory";

export class MakeGMBChartsBase {
  makeCharts({ gmbData }) {
    this._setGmbData(gmbData);
    this._createData();
  }

  returnCharts() {
    return this.charts;
  }

  _setGmbData(gmbData) {
    this._gmbData = gmbData;
  }

  _createData() {
    for (const chartName of Object.keys(this._chartsConfig)) {
      this._chartsConfig[chartName].relatedChartsData = this._setMetricData(
        this._chartsConfig[chartName].metrics
      );
      this._createChart(chartName);
    }
  }

  _setMetricData(metrics) {
    const selectedData = [];
    for (const metric of metrics) {
      selectedData.push(
        this._gmbData.find(gmbElement => gmbElement.metric === metric)
      );
    }
    return selectedData;
  }

  _createChart(chartName) {
    const chartFactory = new GMBChartsFactory();
    chartFactory.makeChart({
      type: this._chartsConfig[chartName].type,
      chartConfig: this._chartsConfig[chartName]
    });
    this.charts[chartName] = chartFactory.returnChart();
  }
}
